import React from "react";
import { COUNTER_LIST_ONE } from "../../mocks/counter";
import { Odometer } from "../Odometer/Odometer";

export const CounterAreaOne = () => {
  return (
    <section className="counter-area counter-bg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center mb-50">
              <span className="sub-title">Trusted Advisors Since 2015</span>
              <h2 className="title">Experience that supports confident growth</h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {COUNTER_LIST_ONE.map((item) => (
            <div key={item.id} className="col-lg-3 col-md-4 col-sm-6">
              <div className="counter-item">
                <h2 className="count">
                  <Odometer end={item.count} />
                  {item.suffix}
                </h2>
                <p>{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="counter-shape-wrap">
        <img src="/images/home/blue_ball.png" alt="" className="animationFramesOne" />
        <img src="/images/home/red_ball.png" alt="" className="animationFramesOne" />
      </div>
    </section>
  );
};
